import { Component, OnInit } from '@angular/core';

import { XmStore } from 'core/services';
import { StateService } from '@uirouter/core';
import { AddonsUtil } from 'my-account/activity/line-detail/addon/services/addons-util';

@Component({
    selector: 'xm-addon-progress',
    templateUrl: './addon-progress.html',
    styleUrls: ['./addon-progress.scss'],
    standalone: false
})

export class XmAddonProgress implements OnInit {
    private addonsUtil: AddonsUtil;

    constructor(xmStore: XmStore, state: StateService, addonsUtil: AddonsUtil) {
        Object.assign(this, { xmStore, state, addonsUtil });
    }

    public ngOnInit(): void {
        this.addonsUtil.initAddonsPolling();
    }
}
